export default "<div id=\"rating-container\">\n  <!-- Ratings will be injected here by TypeScript -->\n</div>";